var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZkDyiETs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.06 10.5165C12.8731 10.7197 12.8863 11.036 13.0895 11.2229C13.2927 11.4099 13.6091 11.3967 13.796 11.1934L13.06 10.5165ZM19.879 4.36405C19.8674 4.08815 19.6344 3.87383 19.3585 3.88535L14.8625 4.07308C14.5865 4.0846 14.3722 4.3176 14.3837 4.5935C14.3953 4.86941 14.6283 5.08373 14.9042 5.07221L18.9007 4.90534L19.0676 8.90185C19.0791 9.17776 19.3121 9.39208 19.588 9.38056C19.8639 9.36904 20.0782 9.13604 20.0667 8.86014L19.879 4.36405ZM13.796 11.1934L19.7474 4.72341L19.0114 4.04642L13.06 10.5165L13.796 11.1934Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9206 13.4616C11.108 13.2589 11.0956 12.9425 10.8929 12.7551C10.6901 12.5676 10.3738 12.58 10.1863 12.7827L10.9206 13.4616ZM4.11643 19.5635C4.12725 19.8394 4.3597 20.0543 4.63563 20.0435L9.13218 19.8673C9.40811 19.8565 9.62303 19.624 9.61222 19.3481C9.6014 19.0722 9.36895 18.8572 9.09302 18.8681L5.09609 19.0247L4.93947 15.0277C4.92865 14.7518 4.6962 14.5369 4.42027 14.5477C4.14434 14.5585 3.92942 14.791 3.94023 15.0669L4.11643 19.5635ZM10.1863 12.7827L4.24892 19.2044L4.98318 19.8833L10.9206 13.4616L10.1863 12.7827Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5956 2.88588L22.604 21.1114C22.6044 21.9377 21.9351 22.6051 21.1044 22.6053L2.89557 22.6106C2.06698 22.6108 1.39514 21.9392 1.39514 21.1106V2.88892C1.39514 2.06049 2.06671 1.38892 2.89514 1.38892H21.0956C21.9245 1.38892 22.5952 2.05848 22.5956 2.88588Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZkDyiETs);
export default __webpack_public_path__ + "static/media/ZKDyiETs.3e1c81a78cde1cbb05a08b22d8962602.svg";
export { ForwardRef as ReactComponent };